<div class="modal-body tw-p-10 tw-text-center">
  
  <div class="tw-flex tw-justify-center tw-mb-8">
    <div class="success-icon-container">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 13L9 17L19 7" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <h2 class="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-3">{{ 'mysec.submittedSuccessfully' | translate }}</h2>
  <p class="tw-text-lg tw-text-gray-500 tw-font-normal tw-mb-10">{{ 'mysec.teamWillReview' | translate }}</p>

  <button (click)="activeModal.close()" class="btn-success-ok">
    {{ 'common.ok' | translate }}
  </button>
</div>